import { render } from "./SaleEditBovine.vue?vue&type=template&id=f12acca0&scoped=true"
import script from "./SaleEditBovine.vue?vue&type=script&lang=js"
export * from "./SaleEditBovine.vue?vue&type=script&lang=js"

import "./SaleEditBovine.vue?vue&type=style&index=0&id=f12acca0&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12acca0"]])

export default __exports__